import React from "react";
import { Flex, LoadingIndicator } from "@jsq/ds/core";
import styles from "./styles.scss";

export const LoadingSpinner = () => (
  <Flex
    className={styles.LoadingSpinner__container}
    justifyContent="center"
    alignItems="center"
    data-testid="staff-review-loader"
  >
    <LoadingIndicator variant="primary" />
  </Flex>
);
